module.exports = __webpack_public_path__ + "img/ENDORSE_MY_SKILLS.0a36bd93.svg";